import React, { FC } from "react"

import useTheme from "../../features/Theme/ThemeProvider"
import { IBodyProps, Text } from "./common"

export const Caption: FC<IBodyProps> = props => {
  const theme = useTheme()

  // noinspection RequiredAttributes
  return <Text {...props} type={theme.typography.caption} theme={theme} />
}
